import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import _ from 'lodash';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PublicService {

  constructor(
    private httpClient: HttpClient,
  ) { }

  // [GET] public groups
  public getPublicGroups(tournamentId: string): Observable<{ [index: string]: any; }> {
    return this.httpClient.get<HttpResponse<object>>
    (environment.api_server + _.replace(environment.api_endpoints.publicGroups, ':id', tournamentId), {
      params: {}, observe: 'response'
    });
  }

  // [GET] public standings
  public getPublicStandings(tournamentId: string): Observable<{ [index: string]: any; }> {
    return this.httpClient.get<HttpResponse<object>>
    (environment.api_server + _.replace(environment.api_endpoints.publicStandings, ':id', tournamentId), {
      params: {}, observe: 'response'
    });
  }

  // [GET] public rounds
  public getPublicRounds(tournamentId: string): Observable<{ [index: string]: any; }> {
    return this.httpClient.get<HttpResponse<object>>
    (environment.api_server + _.replace(environment.api_endpoints.publicRounds, ':id', tournamentId), {
      params: {}, observe: 'response'
    });
  }

  // [GET] public round matches
  public getPublicMatches(roundId: string): Observable<{ [index: string]: any; }> {
    return this.httpClient.get<HttpResponse<object>>
      (environment.api_server + _.replace(environment.api_endpoints.publicMatches, ':id', roundId), {
        params: {}, observe: 'response'
      });
  }
}
